<ng-container *ngIf="settings && value">
    <div class="layout horizontal space-between middle" style="margin-bottom: 12px;">
        <div style="font-size: 20px;">{{sectionLabel}}<span *ngIf="!['card'].includes(mode) && settings.required">*</span></div>
        <app-button *ngIf="!['card'].includes(mode) && !(settings.occurrences && settings.occurrences.max && asArray(value).length >= settings.occurrences.max) " type="icon" icon="plus-circle" [action]="emitAdd.bind(this)"></app-button>
    </div>
    <div *ngFor="let document of value; let i = index" class="layout horizontal space-between top">
        <div style="width: 100%;">
            <app-form-field [type]="type"
                            [label]="label+' '+(i+1)" [mode]="mode"
                            [hint]="hint"
                            [settings]="settingsWithRequiredAttributeReplacedByNotEmptyAttribute"
                            [value]="value[i]" 
                            (modelChange)="emitModelChange($event,i)"
                            [specifiedAttributes]="specifiedAttributes">
            </app-form-field>
        </div>
        <app-button *ngIf="!['card'].includes(mode)" type="icon" icon="close" (click)="deleteClick(i)" style="margin-top: 8px;"
                    [settings]="{fontColor: '#757575'}"></app-button>
    </div>
    <div *ngIf="!value || asArray(value).length==0" style="height: 50px; color: #999;">
        {{placeholder}}
    </div>
</ng-container>